import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {Act, Data, Pagination, Period} from "../../types/payments/actsSchema";


const initialState = {
    items: [] as Act[],
    periods: [] as Period[],
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};


const actsSlice = createSlice({
    name: "acts",
    initialState,
    reducers: {
        setActs: (state, action: PayloadAction<Data>) => {
            const { items,periods, pagination } = action.payload;
            state.items = items;
            state.periods = periods;
            state.isLoading = false;
            state.pagination = pagination;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});

export const { setActs,setLoading } = actsSlice.actions;
export const actsReducer = actsSlice.reducer;

